export enum ItemfluxObjectType  {
     Catalogue = 0,
     Univers = 1,
     Rubrique = 2,
     Famille = 3,
}